function deleteParamFromCurrentUrl(paramToDelete) {
  // get the current URL
  const currentUrl = new URL(window.location.href);

  // get the search parameters from the current URL
  const params = currentUrl.searchParams;

  // delete the parameter
  params.delete(paramToDelete);

  // set the new search params back to the URL
  currentUrl.search = params.toString();

  // use history.pushState to update the URL in the browser address bar
  window.history.pushState({}, "", currentUrl.toString());
}

function clearParamsFromCurrentUrl() {
  // get the current URL
  const currentUrl = new URL(window.location.href);

  // clear the search parameters
  currentUrl.search = "";

  // use history.pushState to update the URL in the browser address bar
  window.history.pushState({}, "", currentUrl.toString());
}

export { deleteParamFromCurrentUrl, clearParamsFromCurrentUrl };
